import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { setReceivingUSNG } from '../store/destinationAddress.actions'
import { LLtoUSNGwrapper } from '../../../utilities'
import { DestinationAddressConstants } from '../store/destinationAddress.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* calculateReceivingUSNG(gpsn: string, gpse: string) {
  const gpsn_pattern = new RegExp('^((\\+|-)?(90(\\.[0]{1,6})?|([1-8][0-9]|[0-9])(\\.[0-9]{1,6})?))$')
  const gpse_pattern = new RegExp('^((\\+|-)?(180(\\.[0]{1,6})?|(1[0-7][0-9]|[1-9][0-9]|[0-9])(\\.[0-9]{1,6})?))$')
  if (gpsn !== '' && gpse !== '' && gpsn_pattern.test(gpsn) && gpse_pattern.test(gpse)) {
    const usng = LLtoUSNGwrapper(parseFloat(gpsn.toString()), parseFloat(gpse.toString()), 4)
    return usng
  }
}

export function* setCalculateReceivingUSNG() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const destinationAddress = pcrDoc.disposition?.destination
      if (destinationAddress && Object.keys(destinationAddress).length !== 0) {
        const usng: string = yield call(calculateReceivingUSNG, destinationAddress.gpsn, destinationAddress.gpse)
        if (usng) {
          yield put(setReceivingUSNG(usng))
        }
      }
    } catch (e) {
      yield put(throwPcrException(`setCalculateReceivingUSNG() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCalculateReceivingUSNGSaga() {
  yield takeLatest(
    [DestinationAddressConstants.CALCULATE_RECEIVING_USNG],
    performWithMutexHOG,
    setCalculateReceivingUSNG
  )
}
